import React from 'react';
import { StatusIcon } from './StatusIcon';

export function StatusIconExample(): JSX.Element {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <StatusIcon text="good" color="var(--color-success)" />
      <StatusIcon color="var(--color-error)" />
    </div>
  );
}
